module.exports = __webpack_public_path__ + "img/drone-service.325533e9.svg";